export enum TasksUpdate {
    UPDATE_TASKS_ASSIGNED_TO_CURRENT = 'UPDATE_TASKS_ASSIGNED_TO_CURRENT',
    UPDATE_ALL_TASKS = 'UPDATE_ALL_TASKS',
}
